module.exports = "/_next/static/images/DiscoverAndActivate-d8f985865f730650b11efd57b74d5b89.webp";